export default __webpack_public_path__ + "static/media/demandapp_azul.a47d8633.svg";